export class Week {
    start: string;
    end: string;
    label: string;
    days: number;
    month: string;
    constructor (data) {
        this.start =  data.start;
        this.end =  data.end;
        this.label =  data.label;
        this.days =  data.days;
        this.month =  data.month;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/category/week.ts